import ReportsScreen from '../../components/reports/ReportsScreen';
import { useGenerateAdminReportMutation } from '../../features/reports/reportsApi';

// GET /admin/reports — permission: view-reports. Any type including kyc.
export default function Reports() {
  return (
    <ReportsScreen
      scope="admin"
      useGenerateReportMutation={useGenerateAdminReportMutation}
      permissionDeniedMessage="Your admin account doesn't have the view-reports permission needed to generate reports."
    />
  );
}
